import { render, staticRenderFns } from "./DefectGroupInput.vue?vue&type=template&id=15929807&"
import script from "./DefectGroupInput.vue?vue&type=script&lang=js&"
export * from "./DefectGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports